export default class BoardColumnEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#board_column_id") ? (elem.querySelector("#board_column_id") as HTMLInputElement).value : null,
            name: (elem.querySelector("#board_column_name") as HTMLInputElement).value,
            status_id: (elem.querySelector("#board_column_status_id option:checked") as HTMLInputElement).value,
        }
    }
}